import React, { useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import AddOnsTab from './AddOnsTab';
import AccidentCover from './AccidentCover';
import Accessories from './Accessories';

function CarsTab() {
    const [activeTab, setActiveTab] = useState(1);

    const handleClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };

    return (
        <div className="tabs-container row">
            <div className="tabs col-4">
                <Scrollbars style={{ height: 400 }} >
                    <div className={`tab ${activeTab === 1 ? 'active' : ''}`} onClick={() => handleClick(1)}>Addons</div>
                    <div className={`tab ${activeTab === 2 ? 'active' : ''}`} onClick={() => handleClick(2)}>Accident covers</div>
                    <div className={`tab ${activeTab === 3 ? 'active' : ''}`} onClick={() => handleClick(3)}>Accessories cover</div>

                    {/* Add more tabs as needed */}
                </Scrollbars>
            </div>
            <div className="tab-content col-7">
                {activeTab === 1 && <div><AddOnsTab /></div>}
                {activeTab === 2 && <div><AccidentCover /></div>}
                {activeTab === 3 && <div><Accessories /></div>}
                {/* Add corresponding content for each tab */}
            </div>
        </div>
    );
}

export default CarsTab;
